import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { createTextMaskInputElement } from 'text-mask-core';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';

interface Cliente {
  id?: number;
  iD_USUARIO_CLIENTE?: number;
  nome: string;
  cpf: string;
  email: string;
  telefone: string;
  endereco: string;
  tipO_DEMANDA: string;
  status: string;
  dataCadastro: Date;
}

interface Arquivo {
  id: number;
  nome: string;
  tipo: string;
  dataUpload: Date;
  path: string;
}

interface MembroArvore {
  parentesco?: string;
  italiano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  filhoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  netoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  bisnetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  trinetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  tetranetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  pentanetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  hexanetoItaliano?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    dataObito?: string;
    localObito?: string;
  };
  cliente?: {
    nomeCompleto: string;
    dataNascimento: string;
    localNascimento: string;
    nomeConjuge?: string;
    dataCasamento?: string;
    localCasamento?: string;
    filhos?: string;
    netos?: string;
  };
}

@Component({
  selector: 'app-cadastro-cliente',
  templateUrl: './cadastro-cliente.component.html',
  styleUrls: ['./cadastro-cliente.component.scss']
})
export class CadastroClienteComponent implements OnInit {
  @ViewChild('formModal') formModal!: TemplateRef<any>;
  @ViewChild('arquivosModal') arquivosModal!: TemplateRef<any>;
  @ViewChild('arvoreModal') arvoreModal!: TemplateRef<any>;

  cadastroForm: FormGroup;
  modalRef!: NgbModalRef;
  clienteSelecionado: any;
  clientes: Cliente[] = [];
  clientesFiltrados: Cliente[] = [];
  loading: boolean = false;
  loadingArquivos: boolean = false;
  loadingArvore: boolean = false;
  arquivosCliente: Arquivo[] = [];
  arvoreCliente: MembroArvore | null = null;

  // Paginação
  pageIndex: number = 0;
  pageSize: number = 10;

  // Filtros
  filtroNome: string = '';
  filtroCpf: string = '';
  filtrotipO_DEMANDA: string = '';
  filtroStatus: string = '';

  // Máscaras
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService
  ) {
    this.cadastroForm = this.fb.group({
      nome: ['', Validators.required],
      cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      endereco: ['', Validators.required],
      tipO_DEMANDA: ['', Validators.required],
      status: ['ativo', Validators.required]
    });
  }

  ngOnInit(): void {
    this.carregarClientes();
  }

  carregarClientes(): void {
    this.loading = true;
    let url = API + "UsuarioCliente/UsuarioCliente";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.clientes = response.data;
        this.clientesFiltrados = [...this.clientes];
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar clientes:', error);
        this.loading = false;
      }
    });
  }

  openModal(modal: TemplateRef<any>, isNew: boolean = false): void {
    if (isNew) {
      this.clienteSelecionado = null;
      this.cadastroForm.reset({ status: 'ativo' });
    }
    this.modalRef = this.modalService.open(modal, { size: 'lg' });
  }

  editarCliente(cliente: Cliente): void {
    this.clienteSelecionado = cliente;
    this.cadastroForm.patchValue(cliente);
  }

  visualizarDetalhes(cliente: Cliente): void {
    // TODO: Implementar visualização detalhada do cliente
    console.log('Visualizar detalhes:', cliente);
  }

  onSubmit(): void {
    debugger
    if (this.cadastroForm.valid) {
      const formValue = this.cadastroForm.value;
      let dados = {
        "ID_USUARIO": this.clienteSelecionado.iD_USUARIO,
        "ID_USUARIO_CLIENTE": this.clienteSelecionado.iD_USUARIO_CLIENTE,
        "NOME": formValue.nome,
        "CPF": formValue.cpf,
        "EMAIL": formValue.email,
        "TELEFONE": formValue.telefone,
        "ENDERECO": formValue.endereco,
        "TIPO_DEMANDA": formValue.tipO_DEMANDA,
        "STATUS": formValue.status
      };

      let url = API + "Usuario/Usuario/cliente";
      


        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarClientes();
            this.modalRef.close();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao atualizar cliente:', error);
          }
        });
    
        
    }
  }

  aplicarFiltros(): void {
    this.clientesFiltrados = this.clientes.filter(cliente => {
      const matchNome = !this.filtroNome || 
        cliente.nome.toLowerCase().includes(this.filtroNome.toLowerCase());
      const matchCpf = !this.filtroCpf || 
        cliente.cpf.includes(this.filtroCpf);
      const matchTipoDemanda = !this.filtrotipO_DEMANDA || 
        cliente.tipO_DEMANDA === this.filtrotipO_DEMANDA;
      const matchStatus = !this.filtroStatus || 
        cliente.status === this.filtroStatus;

      return matchNome && matchCpf && matchTipoDemanda && matchStatus;
    });
    this.pageIndex = 0; // Reset para primeira página ao filtrar
  }

  limparFiltros(): void {
    this.filtroNome = '';
    this.filtroCpf = '';
    this.filtrotipO_DEMANDA = '';
    this.filtroStatus = '';
    this.clientesFiltrados = [...this.clientes];
    this.pageIndex = 0; // Reset para primeira página ao limpar filtros
  }

  gettipO_DEMANDALabel(tipo: string): string {
    const labels: { [key: string]: string } = {
      'jure_sanguinis': 'Jure Sanguinis',
      'filho_menor': 'Filho Menor',
      'outra_demanda': 'Outra Demanda'
    };
    return labels[tipo] || tipo;
  }

  // Métodos de paginação
  onPageChange(newPageIndex: number): void {
    this.pageIndex = newPageIndex;
  }

  onPageSizeChange(): void {
    this.pageIndex = 0; // Reset para primeira página ao mudar o tamanho
  }

  getTotalPages(): number {
    return Math.ceil(this.clientesFiltrados.length / this.pageSize);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }

  carregarArquivos(cliente): void {
    this.loadingArquivos = true;
    this.clienteSelecionado = cliente;
    
    debugger
    let url = API + "Arquivos/Arquivos?ID_USUARIO=" + cliente.iD_USUARIO;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.arquivosCliente = response.data;
        this.loadingArquivos = false;
      },
      error: (error) => {
        console.error('Erro ao carregar arquivos:', error);
        this.loadingArquivos = false;
      }
    });
  }

  visualizarArquivo(arquivo: Arquivo): void {
    window.open(arquivo.path, '_blank');
  }

  excluirArquivo(arquivo: Arquivo): void {
    if (confirm('Tem certeza que deseja excluir este arquivo?')) {
      let url = API + "Arquivo/Arquivo/" + arquivo.id;
      this.ajaxService.delete(url).subscribe({
        next: (response) => {
          this.arquivosCliente = this.arquivosCliente.filter(a => a.id !== arquivo.id);
        },
        error: (error) => {
          console.error('Erro ao excluir arquivo:', error);
        }
      });
    }
  }

  carregarArvore(cliente): void {
    debugger;
    this.clienteSelecionado = cliente;
    this.arvoreCliente = JSON.parse(this.clienteSelecionado.arvore);
    this.loadingArvore = false;
  }

  getParentescoLabel(parentesco?: string): string {
    switch (parentesco) {
      case 'italiano':
        return 'Italiano/a';
      case 'filho':
        return 'Filho/a do/a Italiano/a';
      case 'neto':
        return 'Neto/a do/a Italiano/a';
      case 'bisneto':
        return 'Bisneto/a do/a Italiano/a';
      case 'trineto':
        return 'Trineto/a do/a Italiano/a';
      case 'tetraneto':
        return 'Tetraneto/a do/a Italiano/a';
      case 'pentaneto':
        return 'Pentaneto/a do/a Italiano/a';
      case 'hexaneto':
        return 'Hexaneto/a do/a Italiano/a';
      default:
        return 'Cliente';
    }
  }
} 